import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid px-5" }
const _hoisted_2 = { class: "col-4 filter-container" }
const _hoisted_3 = {
  key: 0,
  class: "grid custom-filter-container p-4"
}
const _hoisted_4 = { class: "col-auto mr-3 my-1" }
const _hoisted_5 = { class: "col-auto mr-3 my-1" }
const _hoisted_6 = { class: "col px-4 indicators-container" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "grid mt-4" }
const _hoisted_9 = { class: "col-8" }
const _hoisted_10 = {
  class: "",
  style: {"background-color":"white","border-radius":"8px"}
}
const _hoisted_11 = { class: "col-4" }
const _hoisted_12 = {
  class: "mb-1",
  style: {"background-color":"white","border-radius":"8px"}
}
const _hoisted_13 = { class: "card flex justify-center" }
const _hoisted_14 = {
  class: "chart container",
  style: {"background-color":"white","border-radius":"8px"}
}
const _hoisted_15 = { class: "card justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_select = _resolveComponent("p-select")!
  const _component_p_calendar = _resolveComponent("p-calendar")!
  const _component_stat_card = _resolveComponent("stat-card")!
  const _component_stat_container = _resolveComponent("stat-container")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "text-3xl font-bold text-blue-800" }, "Tableau de bord", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-lg" }, "FILTRES", -1)),
        _createVNode(_component_p_select, {
          class: "mb-4",
          label: "Mairie",
          optionLabel: "text",
          placeholder: "Sélectionnez une mairie",
          modelValue: _ctx.selectedMairie,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMairie) = $event)),
          options: _ctx.mairieOptions
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_p_select, {
          label: "Période",
          optionLabel: "text",
          placeholder: "Sélectionnez une période",
          options: _ctx.filterOptions,
          modelValue: _ctx.selectedFilter,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFilter) = $event)),
          optionValue: "value",
          showClear: true
        }, null, 8, ["options", "modelValue"]),
        (_ctx.selectedFilter === 'custom')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_p_calendar, {
                  modelValue: _ctx.startDate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event)),
                  label: "Date de début",
                  placeholder: "Date de début",
                  dateFormat: "dd/mm/yy"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_p_calendar, {
                  modelValue: _ctx.endDate,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
                  label: "Date de fin",
                  placeholder: "Date de fin",
                  dateFormat: "dd/mm/yy"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyCustomFilter && _ctx.applyCustomFilter(...args))),
                class: "p-button p-button-sm my-1"
              }, "Valider")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-lg" }, "INDICATEURS", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_stat_container, null, {
            cards: _withCtx(() => [
              _createVNode(_component_stat_card, {
                icon: "person_add",
                title: "Naissances",
                value: _ctx.totalBirths,
                colorClass: "flat-blue-color"
              }, null, 8, ["value"]),
              _createVNode(_component_stat_card, {
                icon: "person_remove",
                title: "Décès",
                value: _ctx.totalDeaths,
                colorClass: "flat-blue-color"
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "text-lg col-12 ml-4" }, "GRAPHIQUES", -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-base p-2" }, "Répartition des Naissances et Décès par mois", -1)),
          _createVNode(_component_Chart, {
            type: "bar",
            data: _ctx.chartData,
            options: _ctx.chartOptions,
            style: {"height":"500px"}
          }, null, 8, ["data", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-base p-2" }, "Naissances: Répartition par sexe", -1)),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Chart, {
              type: "pie",
              data: _ctx.genderBirthChartData,
              options: _ctx.genderBirthChartOptions,
              class: "w-full ml-8 md:w-[30rem]"
            }, null, 8, ["data", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-base p-2" }, "Décès: Répartition par sexe", -1)),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_Chart, {
              type: "doughnut",
              data: _ctx.genderDeathChartData,
              options: _ctx.genderDeathChartOptions,
              class: "w-full ml-8 md:w-[30rem]"
            }, null, 8, ["data", "options"])
          ])
        ])
      ])
    ])
  ]))
}